/**
 * Read the JSON body an Edge Function attached to a non-2xx response. supabase-js
 * surfaces it as `FunctionsHttpError` with the `Response` on `context`; callers
 * map `body.error` to their own typed error. Null when there is no JSON body.
 */
export async function readEdgeFunctionErrorBody(
  error: unknown,
  response: Response | undefined
): Promise<Record<string, unknown> | null> {
  const resp =
    response ??
    ((error as { context?: unknown } | null)?.context instanceof Response
      ? ((error as { context: Response }).context)
      : undefined);
  if (!(resp instanceof Response)) {
    return null;
  }
  try {
    return (await resp.clone().json()) as Record<string, unknown>;
  } catch {
    return null;
  }
}
